import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";

const insightsImg =
  "https://images.unsplash.com/photo-1618044733300-9472054094ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBncmFwaHMlMjBkb2N1bWVudHMlMjBkZXNrfGVufDB8fHx8MTc4MTI2OTMzM3ww&ixlib=rb-4.1.0&q=85";

const articles = [
  {
    tag: "Direct Tax",
    title:
      "CBDT to notify new Income-tax Rules and forms by end-December 2025, ahead of the Income-tax Act, 2025 taking effect from 1 April 2026.",
    date: "Dec 2025",
  },
  {
    tag: "Direct Tax",
    title:
      "Notification No. 170/2025 — specified Commissioner of Income-tax (Appeals) officers directed to exercise appellate powers in specified cases.",
    date: "15 Dec 2025",
  },
  {
    tag: "GST",
    title:
      "CBIC issues Notifications 19/2025 and 20/2025 — Central Tax — implementing rule and procedural changes for FY 2025-26.",
    date: "31 Dec 2025",
  },
  {
    tag: "GST",
    title:
      "56th GST Council meet outcomes implemented — rate and rule changes effective 22 September 2025 via 17 Sep CBIC notifications.",
    date: "22 Sep 2025",
  },
  {
    tag: "Companies Act",
    title:
      "Small company thresholds raised — paid-up capital up to ₹10 crore and turnover up to ₹100 crore. Companies (Specification of Definition Details) Amendment Rules, 2025.",
    date: "01 Dec 2025",
  },
  {
    tag: "Companies Act",
    title:
      "MCA Circular 08/2025 extends due dates for several annual filing forms to 31 January 2026.",
    date: "Dec 2025",
  },
  {
    tag: "Companies Act",
    title:
      "Annual DIR-3 KYC to be replaced by KYC intimation once every three years — effective 31 March 2026.",
    date: "Mar 2026",
  },
];

export default function Insights() {
  return (
    <section id="insights" data-testid="insights-section" className="py-24 md:py-32 bg-[#FDFBF7]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-5"
        >
          <div className="overline mb-5">/ Insights</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight text-[#1B3B2B]">
            Notes from the desk on tax, audit and Indian regulation.
          </h2>
          <p className="mt-6 text-[#4A5D53] text-base leading-relaxed max-w-md">
            Short, written commentary from our partners — drafted for promoters and finance teams
            who need the position, not the press release.
          </p>
          <div className="mt-8 overflow-hidden">
            <img
              src={insightsImg}
              alt="Financial documents and charts"
              className="w-full object-cover"
              data-testid="insights-image"
            />
          </div>
        </motion.div>

        <div className="lg:col-span-7 lg:pl-12 lg:border-l lg:border-[#D1CEC5]">
          <ul className="divide-y divide-[#D1CEC5]">
            {articles.map((a, i) => (
              <motion.li
                key={a.title}
                data-testid={`insight-item-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="py-8 group cursor-pointer"
              >
                <div className="flex items-baseline justify-between gap-4">
                  <div className="overline text-[10px]">{a.tag}</div>
                  <div className="overline text-[10px] text-[#4A5D53]">{a.date}</div>
                </div>
                <div className="mt-3 flex items-start justify-between gap-6">
                  <h3 className="font-serif-display text-2xl md:text-3xl leading-snug text-[#1B3B2B] group-hover:text-[#D4AF37] transition-colors duration-300">
                    {a.title}
                  </h3>
                  <ArrowUpRight
                    size={22}
                    className="text-[#1B3B2B] mt-2 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                  />
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
